<!-- 会员证书 -->
<template>
	<div class="item1_box">
		<!-- <img :src="crturl"/> -->
		<iframe style="height:800px" width=100% :src="`${crturl}`" ></iframe>
		<vipLogin ref="vipbox"></vipLogin>
	</div>
</template>

<script>
	import vipLogin from '@/components/vip_login.vue'
	export default {
		components: {
			vipLogin
		},
		data() {
			return {
				crturl:''
			}

		},
		mounted() {
			if(this.$Cookies.get('userInfo')){
				this.crturl = JSON.parse(this.$Cookies.get('userInfo')).user.crturl;
			}else{
				this.$refs['vipbox'].showLogin = true;
				this.$refs['vipbox'].isHYZS = true;
			}
		},
		methods: {
			
		}
	}
</script>

<style lang="scss" scoped>
	.item1_box {
		img{
			width: 100%;
		}
	}
</style>
